<template>
  <div>
    <Title
      title="Gestión de Transportes"
      subtitle="Lista de patentes"/>
    <el-row :gutter="30">
      <el-col>
        <search-vehicles @search="search"/>
        <vehicle-list ref="list"/>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import Title from '../components/base/Title.vue';
import VehicleList from '../components/vehicle/List.vue';
import SearchVehicles from '../components/vehicle/Search.vue';

export default {
  name: 'Vehicles',
  components: {
    Title,
    VehicleList,
    SearchVehicles,
  },
  methods: {
    search(params) {
      this.$refs.list.search(params);
    },
  },
};
</script>

<style lang="scss" scoped>

</style>
